import type { ReactElement } from 'react';

/**
 * phase-validation-rules-screen — downstream honesty tag for validation
 * RESULTS: a failure of an AutoeCTD internal check must never read as an
 * agency rejection. Renders a small "AutoeCTD check" tag for internal-origin
 * rules and NOTHING for agency rules (the routine case stays quiet; the
 * different-consequences case is labelled). Shared by the notification
 * drawer worklist and the validation report modal so the two surfaces
 * cannot drift.
 */
export function RuleOriginTag({ origin }: { origin?: string | null }): ReactElement | null {
  if (origin !== 'internal') return null;
  return (
    <span
      data-testid="rule-origin-internal-tag"
      title="AutoeCTD’s own quality check — not a regulator requirement"
      style={{
        display: 'inline-block',
        marginLeft: 6,
        padding: '0 6px',
        borderRadius: 999,
        fontSize: 10,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        background: '#e0e7ff',
        color: '#3730a3',
        border: '1px solid #c7d2fe',
        verticalAlign: 'middle',
      }}
    >
      AutoeCTD check
    </span>
  );
}
